import { updateDomComponent } from "@theme/base";

class VariantPicker extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const signal = this.#abortController.signal;
    const selects = [...this.querySelectorAll("select[data-select]")];
    if (!selects.length) return;

    const form = this.closest("form");
    const submitButton = form?.querySelector('[type="submit"]');

    // Selects carry option names (S/M/L), not variant IDs — strip name="id" to avoid bad form data
    selects.forEach(s => s.removeAttribute("name"));

    // Single hidden input owns the variant ID submitted with the form
    const idInput = form?.querySelector('input[name="id"]') ?? (() => {
      const el = Object.assign(document.createElement("input"), { type: "hidden", name: "id" });
      form.appendChild(el);
      return el;
    })();

    const getVariant = () => {
      const values = selects.map(s => s.value);
      if (values.some(v => !v)) return null;
      return this.querySelector(`input[data-options="${values.join(",")}"]`);
    };

    const updateSubmitButton = (variant) => {
      if (!submitButton) return;
      const available = variant && !variant.disabled;
      const text = !variant
        ? submitButton.dataset.selectText || "Select variant"
        : available
          ? submitButton.dataset.availableText || "Add to cart"
          : submitButton.dataset.unavailableText || "Notify Me";

      const textSpan = submitButton.querySelector(".btn-text");
      if (textSpan) textSpan.textContent = text;
      else submitButton.textContent = text;

      if(submitButton.dataset.useNotifyMe == 'true') {
        submitButton.disabled = false;
        submitButton.setAttribute("aria-disabled", false);
        submitButton.classList.toggle("use-notify-me", !!variant && !available);
      }
      else {
        submitButton.disabled = !available;
        submitButton.setAttribute("aria-disabled", String(!available));
      }
    };

    const updatePage = async (variantId) => {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantId);

      if (document.body.classList.contains("template-product")) {
        window.history.pushState({ variantId }, "", url.toString());
        await updateDomComponent([".product_price"], ["product"], url.toString());
      }

      this.dispatchEvent(new CustomEvent("variant-change", {
        bubbles: true,
        composed: true,
        detail: { variantId },
      }));
    };

    const onChange = () => {
      const variant = getVariant();
      if (variant) idInput.value = variant.value;
      updateSubmitButton(variant);
      if (variant) updatePage(variant.value);
    };

    selects.forEach(s => s.addEventListener("change", onChange, { signal }));
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }
}

if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}